import React, { isValidElement, useContext, useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CIcon from '@coreui/icons-react';
import { DropdownContext, iconProps } from './CSidebarNavDropdown';
import { CBadge, CLink } from '@coreui/react';
import { NavLink } from 'react-router-dom';
import CTooltip from './CTooltip';

//component - CoreUI / CSidebarNavItem
const CSidebarNavItem = (props) => {
     const {
          children,
          className,
          //
          innerRef,
          name,
          icon,
          fontIcon,
          badge,
          addLinkClass,
          label,
          color,
          isMinimized,
          ...rest
     } = props;

     const { isOpen } = useContext(DropdownContext);
     const badgeRef = useRef(null);
     const spanRef = useRef(null);
     const [badgeWidth, setBadgeWidth] = useState(0);
     const [showTooltip, setShowTooltip] = useState(false);

     useEffect(() => {
          if (badge && badgeRef.current) {
               const width = badgeRef.current.offsetWidth;
               setBadgeWidth(width + 25); // Add some padding
          }
     }, [badge]);

     useEffect(() => {
          // Đợi một chút để CSS transition hoàn thành sau khi toggle minimize
          const timeoutId = setTimeout(() => {
               if (spanRef.current) {
                    const isOverflowing = spanRef.current.scrollWidth > spanRef.current.clientWidth;
                    setShowTooltip(isOverflowing);
               }
          }, 300);
          
          return () => clearTimeout(timeoutId);
     }, [name, badgeWidth, isMinimized]);

     const classes = classNames('sidebar-nav-item', className);

     const linkClasses = classNames(label ? 'sidebar-nav-label' : 'sidebar-nav-link', color && `sidebar-nav-link-${color}`, addLinkClass);

     const routerLinkProps = rest.to && { exact: true, activeClassName: 'c-active' };

     const style = {
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          whiteSpace: 'nowrap',
          transition: 'background .1s, color .1s',
          listStyle: 'none',
     };
     const linkContent = (
          <CLink
               {...(rest.to && { as: NavLink })}
               className={linkClasses}
               style={style}
               {...routerLinkProps}
               {...rest}
               tabIndex={isOpen === false ? -1 : 0}
          >
               {icon && (isValidElement(icon) ? icon : <CIcon {...iconProps(icon)} style={{ maxHeight: '15px', flexShrink: 0 }} />)}
               {fontIcon && <i className={`sidebar-nav-icon ${fontIcon}`} />}
               {showTooltip ? (
                    <CTooltip content={name} customArrow={false}>
                         <span
                              ref={spanRef}
                              style={{
                                   flex: 1,
                                   overflow: 'hidden',
                                   textOverflow: 'ellipsis',
                                   maxWidth: badge && badgeWidth > 0 ? `calc(100% - ${badgeWidth}px)` : '100%',
                                   display: 'inline-block',
                              }}
                         >
                              {name}
                         </span>
                    </CTooltip>
               ) : (
                    <span
                         ref={spanRef}
                         style={{
                              flex: 1,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: badge && badgeWidth > 0 ? `calc(100% - ${badgeWidth}px)` : '100%',
                              display: 'inline-block',
                         }}
                    >
                         {name}
                    </span>
               )}
               {badge &&
                    (badge.tooltip ? (
                         <CTooltip content={badge.tooltip} customArrow={false}>
                              <CBadge ref={badgeRef} style={{ position: 'absolute', right: '18px' }} {...{ ...badge, text: null }}>
                                   {badge.text}
                              </CBadge>
                         </CTooltip>
                    ) : (
                         <CBadge ref={badgeRef} style={{ position: 'absolute', right: '18px' }} {...{ ...badge, text: null }}>
                              {badge.text}
                         </CBadge>
                    ))}
          </CLink>
     );

     return (
          <li className={classes} ref={innerRef}>
               {children || (isMinimized ? <CTooltip content={name} customArrow={false}>{linkContent}</CTooltip> : linkContent)}
          </li>
     );
};

CSidebarNavItem.propTypes = {
     children: PropTypes.node,
     className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
     innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
     icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
     fontIcon: PropTypes.string,
     badge: PropTypes.object,
     addLinkClass: PropTypes.string,
     label: PropTypes.bool,
     name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
     color: PropTypes.string,
};

export default CSidebarNavItem;
